module.exports = __webpack_public_path__ + "static/images/list-bg.d619cf8.png";